import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

function Enterable() {
    const [active, setActive] = useState("Safe Area");
    const navigate = useNavigate();
    return (
        <>
        <Helmet>
    <title>
        Re-Enterable Gel & Fillers | IP68 Cable Protection UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar offers re-enterable gel and fillers for protecting electrical and telecommunication connections against moisture, dust and mechanical damage, with safe area and hazardous area enclosure solutions in the UAE."
    />

    <meta
        name="keywords"
        content="re-enterable gel UAE, re-enterable cable gel UAE, cable jointing gel UAE, IP68 cable protection UAE, cable sealing gel UAE, electrical insulation gel UAE, cable protection solutions UAE, hazardous area junction boxes UAE, cable junction boxes UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/ipconnectors"
    />

    <meta
        property="og:title"
        content="Re-Enterable Gel & Fillers | Cable Protection UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Flexible re-enterable gel and sealing solutions for electrical and telecommunication cable connections, including safe and hazardous area applications."
    />

    <meta
        property="og:url"
        content="https://saig.me/ipconnectors"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="mt-[91px] overflow-hidden relative"
            >
                <motion.img
                    initial={{ scale: 1.2 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 1.2, ease: 'easeOut' }}
                    src="/assets/service/bg3.png"
                    className="w-full lg:h-auto h-[300px] object-cover"
                    alt="	Trusted cable management and termination solutions provider in the UAE"
                />
                <div className="absolute lg:top-[125px] top-[20px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] left-1/2 -translate-x-1/2">
                    <motion.h6
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.7 }}
                        className="font-[500] font-kanit lg:text-[70px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]"
                    >
                        Re-Enterable Gel & Fillers
                    </motion.h6>
                    <motion.p
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.5, duration: 0.7 }}
                        className="max-w-[582px] w-full font-[300] font-inter text-[20px] leading-[30px] text-[#FFFFFF]"
                    >
                        Flexible sealing solutions for safe and easy cable re-entry.
                    </motion.p>
                </div>
                <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="absolute font-[600] font-kanit lg:text-[180px] text-[60px] lg:leading-[180px] leading-[70px] text-[#FFFFFF4F] right-[0px] lg:bottom-[86px] bottom-[40px]"
                >
                    Re-Enterable
                </motion.h1>
            </motion.div>

            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>

                <div className='detail-div-left'>
                    {/* <div className='side-img'>

        <img src='/assets/s.jpg'/>
        <img src='/assets/s.jpg'/>
        <img src='/assets/s.jpg'/>

        </div> */}
                    <div className='main-img'>

                        <img src='/assets/s.jpg' />
                    </div>


                </div>

                <div className='detail-div-right'>
                    <h3>Re-Enterable Gel & Fillers </h3>

                    {/* <p>I've designed and animated a product detail page for a luxury e-commerce platform, focusing on delivering a seamless and premium user experience.</p> */}


                    <h4></h4>
                    {/* <div className='starts'>
    <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
    <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
    <i class="bi bi-star-fill"></i>
  <p>  (4.5) 200 Review 1210 sold</p>
</div> */}
                    <br />
                    <div className='lines'></div>
                    <br />
                    <div className='detail-des'>
                        <p>Description :</p>

                        <h5>Re-Enterable Gel & Fillers are specially formulated insulating and sealing compounds designed for the protection of electrical and telecommunication connections. These materials provide excellent moisture resistance, mechanical protection, and insulation performance, making them ideal for outdoor and underground applications. What sets them apart is their re-enterability – allowing maintenance, inspection, or rewiring without damaging the seal. Easy to apply and remove, these gels and fillers offer a reliable solution for long-term cable joint protection while maintaining flexibility and serviceability.</h5>
                        <br />
                        {/* <button>Buy Now</button> */}
                    </div>
                </div>
            </div>
            <div className='detail-div-p max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] py-[50px]'>
                <h3>Safe Area </h3>

                <p>We offer Ensto cable junction boxes and enclosing solutions for the most demanding with ingress protection ratings as IP66, IP67 and IP68

                    Our enclosing solutions protect your electronic and electrical component in numerous applications from various external risk factors – dust, water, moisture, impact and tampering.

                    Standard Terminal Junction Box with 5 poles terminal are available off the shelf suitable for cable family size 1.5mm2, 2.5mm2, 4mm2, 6mm2, 10mm2, 16mm2, 25mm2, 35mm2 and 50mm2

                    To meet the local & desert climatic condition the junction boxes are 2000 hours UV tested and certified to meet ADQCC and ADM, Abu Dhabi, UAE standards.
                    <br />
                    ● Polycarbonate Enclosures
                    <br />
                    ● Aluminium Enclosures
                    <br />
                    ● Fire Protection Junction Boxes
                    <br />

                    ● FRP Enclosures
                    <br />
                    ● GRP Enclosures
                    <br />

                    ● Distribution Boards
                    <br />
                    ● EMC Enclosures
                </p>
                <br />
                <h3>Hazardous Area  </h3>

                <p>Pepperl+Fuchs and Weidmuller offers various types of Terminals and Junction boxes are available for signal and power distribution networks in hazardous area. Types of explosion protection includes Ex e, Ex ia, Ex tb and Ex op pr for installation in Zones 1/21 and Zone 2/22

                    Options from various available sizes and custom configurations ensures optimal solution for any application.
                    <br />
                    ● Terminal Boxes (Ex e) in Glass Fiber Reinforced Polyester, Stainless Steel 316L, Aluminium
                    <br />

                    ● Terminal Boxes (Ex d IIB+H2) in Aluminium and Stainless Steel 316L
                    <br />

                    ● Terminal Boxes (Ex d IIC) in Aluminium and Stainless Steel 316L
                    <br />

                    ● Terminal Boxes (Ex d) in Aluminium Alloy, Epoxy Coated
                    <br />

                    ● Control Units (Ex e) in Glass Fiber Reinforced Polyester, Stainless Steel
                </p>
            </div>
            <div className='detail-div-p'>


            </div>
            {/* <section style={{ background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }} className='lg:px-[100px] px-[20px]'>
                <h6 className="font-[500] font-kanit lg:text-[42px] text-[30px] lg:leading-[50px] leading-[38px] text-[#000000] lg:pb-[80px] pb-[40px]">Product Recommendation</h6>
                <div className="grid lg:grid-cols-3 grid-cols-2 lg:gap-[36px] gap-[20px] lg:pb-[142px] pb-[80px]">
                    <div>
                        <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                            <img src="/assets/product/img1.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                            <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                View Details
                            </button>
                        </div>
                        <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                            junction box & enclosures
                        </h6>
                        <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                            Polymer & Sheet Metal
                        </p>
                    </div>
                    <div>
                        <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                            <img src="/assets/product/img2.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                            <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                View Details
                            </button>
                        </div>
                        <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                            re-enterable gel 7 fillers
                        </h6>
                        <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                            Re-usable & Cast
                        </p>
                    </div>
                    <div>
                        <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                            <img src="/assets/product/img3.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                            <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                View Details
                            </button>
                        </div>
                        <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                            Cables
                        </h6>
                        <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                            Power & Instrumentation
                        </p>
                    </div>
                </div>
            </section> */}
        </>
    )
}

export default Enterable